import { ThemeVariants } from '@wvr/elements';

export const theme: ThemeVariants = {
  primary: {
    baseColor: '#003C71'
  },
  primaryAccent: {
    baseColor: '#333333'
  },
  primaryNeutral: {
    baseColor: '#e6ecf1'
  },
  secondary: {
    baseColor: '#500000'
  },
  secondaryAccent: {
    baseColor: '#3c0000'
  },
  secondaryNeutral: {
    baseColor: '#D8D8D8'
  },
  success: {
    baseColor: '#00bc8c'
  },
  danger: {
    baseColor: '#E4002B'
  },
  warning: {
    baseColor: '#ffc222'
  },
  info: {
    baseColor: '#5bc0de'
  },
  dark: {
    baseColor: '#343a40'
  },
  light: {
    baseColor: '#f8f9fa'
  }
};
